import { useEffect, Component } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import KeinPassenderTermin from "./pages/KeinPassenderTermin";
import TerminBestaetigt from "./pages/TerminBestaetigt";
import Rechtliches from "./pages/Rechtliches";
import ConsentBanner from "./components/ConsentBanner";
import Footer from "./components/Footer";
import { captureUtms } from "./lib/utm";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }
  static getDerivedStateFromError() {
    return { error: true };
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: "5rem 1.5rem", textAlign: "center", fontFamily: "Raleway, sans-serif", color: "#1F3A5F" }}>
          <p>Es ist ein Fehler aufgetreten. Bitte laden Sie die Seite neu.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    captureUtms();
  }, []);
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/kein-passender-termin" element={<KeinPassenderTermin />} />
          <Route path="/termin-bestaetigt" element={<TerminBestaetigt />} />
          <Route path="/impressum" element={<Rechtliches art="impressum" />} />
          <Route path="/datenschutz" element={<Rechtliches art="datenschutz" />} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
        <Footer />
        <ConsentBanner />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
